module.exports = __webpack_public_path__ + "img/studyset-active.a1be1f10.png";